import React from 'react';

const NotFound = () => {
    return (
        <div>
            <div className="text-center" style={{marginTop: '100px'}}>
                <img style={{width: "300px"}} src="https://thumbs.dreamstime.com/b/error-page-not-found-vector-vinyl-music-broken-graphic-error-page-not-found-vector-vinyl-music-broken-graphic-background-156624909.jpg" alt="" />
            </div>
        </div>
    );
};

export default NotFound;